import { DomainId } from './domain_id';
export * from './domain_id.well-known';
export default DomainId;
//# sourceMappingURL=index.js.map